import React, { useState, useEffect } from 'react'
import Layout from '../../../Layout/Layout'
import { usePage, Link } from '@inertiajs/react'
import FlashMessages from '../Shared/FlashMessages'
import ShowAlerts from '../../../Components/Alerts/ShowAlerts'

export default function Alert({
    participants,
    participant,
    alert_user_id,
    alert_message,
    alert,
    alerts,
}) {
    const { user } = usePage().props
    const { flash, errors } = usePage().props
    const [alertText, setAlertText] = useState('')

    useEffect(() => {
        if (alert == 1)
            setAlertText(
                'This participant should follow up with Supportive Services'
            )
        if (alert == 2)
            setAlertText('This participant should follow up with Medical')

        if (alert == 3)
            setAlertText(
                'This participant should follow up with Drop-In Center Manager'
            )
        if (alert == 4)
            setAlertText(
                'This participant is on Temporary Ban (Contact Manager)'
            )
    })

    return (
        <>
            <div className="bg-gray-100 h-screen w-full flex items-center justify-center">
                <FlashMessages />
                <div className="flex flex-col w-full bg-white shadow-md p-8 md:p-16 container mx-auto max-w-xs md:max-w-lg">
                    <div className="flex flex-col gap-4">
                        {alerts?.length > 0 ? (
                            <ShowAlerts alerts={alerts} showClear={false} />
                        ) : null}
                        {alert != null && (
                            <div className="shadow-sm flex flex-row rounded-md w-full">
                                <div className="flex-0 bg-customRed text-white flex items-center px-2 rounded-tl-md rounded-bl-md">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="h-6 w-6"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                                        />
                                    </svg>
                                </div>
                                <div className="py-4 px-6 flex flex-col">
                                    <p className="text-sm text-customRed font-medium mb-2">
                                        This alert is expired. It should be
                                        cleared and replaced with a new one if
                                        it is still needed.
                                    </p>
                                    <h2 className="text-xl mb-1">
                                        {alertText}
                                    </h2>
                                    <h2 className="text-md mb-2">
                                        {alert_message}
                                    </h2>
                                    <h3 className="text-gray-600 text-sm">
                                        Alert added by {alert_user_id}
                                    </h3>
                                </div>
                            </div>
                        )}
                        {participant.vaccine_alert_status == 0 && (
                            <div className="shadow-sm flex flex-row rounded-md w-full">
                                <div className="flex-0 bg-customRed text-white flex items-center px-2 rounded-tl-md rounded-bl-md">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="h-6 w-6"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                                        />
                                    </svg>
                                </div>
                                <div className="py-4 px-6 flex flex-col">
                                    <h2 className="font-semibold text-xl mb-1">
                                        This participant is not vaccinated
                                    </h2>
                                    <p className="text-sm text-gray-600">
                                        {participant.vaccine_alert_message
                                            ? participant.vaccine_alert_message
                                            : ''}
                                    </p>
                                </div>
                            </div>
                        )}
                        {participant.vaccine_alert_status == 1 && (
                            <div className="shadow-sm flex flex-row rounded-md w-full">
                                <div className="flex-0 bg-customRed text-white flex items-center px-2 rounded-tl-md rounded-bl-md">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="h-6 w-6"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
                                        />
                                    </svg>
                                </div>
                                <div className="py-4 px-6 flex flex-col">
                                    <h2 className="font-semibold text-xl mb-1">
                                        This participant is partially vaccinated
                                    </h2>
                                    <p className="text-sm text-gray-600">
                                        {participant.vaccine_alert_message
                                            ? participant.vaccine_alert_message
                                            : ''}
                                    </p>
                                </div>
                            </div>
                        )}
                        {participant.vaccine_alert_status == 2 && (
                            <div className="shadow-sm flex flex-row rounded-md w-full">
                                <div className="flex-0 bg-customGreen text-white flex items-center px-2 rounded-tl-md rounded-bl-md">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="h-6 w-6"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                        />
                                    </svg>
                                </div>
                                <div className="py-4 px-6 flex flex-col">
                                    <h2 className="font-semibold text-xl mb-1">
                                        This participant is fully vaccinated
                                    </h2>
                                    <p className="text-sm text-gray-600">
                                        {participant.vaccine_alert_message
                                            ? participant.vaccine_alert_message
                                            : ''}
                                    </p>
                                </div>
                            </div>
                        )}
                        {participant.vaccine_alert_status == 3 && (
                            <div className="shadow-sm flex flex-row rounded-md w-full">
                                <div className="flex-0 bg-customGreen text-white flex items-center px-2 rounded-tl-md rounded-bl-md">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="h-6 w-6"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                                        />
                                    </svg>
                                </div>
                                <div className="py-4 px-6 flex flex-col">
                                    <h2 className="font-semibold text-sm">
                                        This participant is fully vaccinated
                                        plus booster
                                    </h2>
                                    <p className="text-sm text-gray-600">
                                        {participant.vaccine_alert_message
                                            ? participant.vaccine_alert_message
                                            : ''}
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                    <h5 className="mb-4 mt-8 text-2xl text-gray-700 font-semibold text-center">
                        Finish with {user.is.currently_seeing}
                    </h5>
                    {participant.vaccine_alert_status != 3 && (
                        <div className="flex flex-row flex-wrap justify-center mb-2">
                            <Link
                                href="/vaccineservice/create"
                                className="p-4 bg-gray-100 flex-grow w-full hover:bg-gray-200 text-center"
                            >
                                Start a new Vaccine Service Form
                            </Link>
                        </div>
                    )}
                    <div className="flex flex-row flex-wrap justify-center mb-2">
                        <Link
                            method="GET"
                            href="/continue"
                            className="p-4 bg-gray-100 flex-grow w-full hover:bg-gray-200 text-center"
                        >
                            Continue With Participant
                        </Link>
                    </div>
                    <div className="flex flex-row flex-wrap justify-center mb-2">
                        <Link
                            href={route('participants.edit', {
                                id: participant.id,
                            })}
                            className="p-4 bg-gray-100 flex-grow w-full hover:bg-gray-200 text-center"
                        >
                            Edit Participant
                        </Link>
                    </div>
                    <div className="flex flex-row flex-wrap justify-center">
                        <Link
                            method="POST"
                            href="/participants/drop"
                            className="p-4 bg-gray-100 flex-grow w-full hover:bg-gray-200 text-center"
                        >
                            Drop Participant
                        </Link>
                    </div>
                    {/* <div className="flex flex-row flex-wrap justify-center">
                    <Link
                        method="POST"
                        href={``}
                        className="p-4 bg-gray-100 flex-grow w-full hover:bg-gray-200 text-center"
                    >
                        Edit Participant
                    </Link>
                </div> */}
                </div>
            </div>
        </>
    )
}
